<template>
    <div class="map">
        <MglMap
            ref="glmap2"
            container="map-test"
            :mapStyle="mapStyle"
            :accessToken="accessToken"
            @load="onMapLoaded"
            :center="center"
            :zoom="zoom"
            @move="move"
            @click="click"

        >
            <MglMarker 
                key="xxx"
                :coordinates="liveCenter"
            >
            </MglMarker>

            <TopBanner/>
        </MglMap>
    </div>
</template>

<style scoped>
.map {
    background-color: green;
    height: 400px;
    z-index: 0;
}
</style>

<script>
//import Vue from 'vue'
import "mapbox-gl/dist/mapbox-gl.css"
import "v-mapbox/dist/v-mapbox.css"
//import Mapbox from "mapbox-gl"
import { MglMap, MglMarker } from "v-mapbox"
import TopBanner from "./map/TopBanner"
export default {
    components: {
        MglMap,
        MglMarker,
        TopBanner
    },
    data() {
        return {
            accessToken: "",
            mapStyle: {
                "version": 8,
                "sources": {
                    "gozhere": {
                        "type": "vector",
                        "tiles": [
                            process.env.VUE_APP_TILE_URL
                        ],
                        "attribution": "<a href=\"https://www.gozhere.com\" target=\"_blank\">© Gozhere</a>",
                        "maxzoom": 20
                    }
                },
                "glyphs": "https://gozhere.com/fonts/{fontstack}/{range}.pbf",
                "layers": [
                    {
                        "id": "background",
                        "type": "background",
                        "paint": {
                            "background-color": "#485E77"
                        }
                    },
                    {
                        "id": "ne_10m_bathymetry_L_0",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "ne_10m_bathymetry_L_0",
                        "paint": {
                            "fill-color": "#5DBCD2"
                        }
                    },
                    {
                        "id": "ne_10m_land",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "ne_10m_land",
                        "paint": {
                            "fill-color": "#EEEDE8"
                        }
                    },
                    {
                        "id": "gis_osm_water_a_free_1",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "gis_osm_water_a_free_1",
                        "paint": {
                            "fill-color": "#AADAFF"
                        }
                    },
                    {
                        "id": "gis_osm_waterways_free_1",
                        "type": "line",
                        "source": "gozhere",
                        "source-layer": "gis_osm_waterways_free_1",
                        "paint": {
                            "line-color": "#AADAFF"
                        }
                    },
                    {
                        "id": "gis_osm_landuse_a_free_1",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "gis_osm_landuse_a_free_1",
                        "paint": {
                            "fill-color": "#DBD8D3"
                        }
                    },
                    {
                        "id": "gis_osm_buildings_a_free_1",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "gis_osm_buildings_a_free_1",
                        "filter": [
                            "in",
                            "fclass",
                            "building"
                        ],
                        "paint": {
                            "fill-color": "#E5E4E2"
                        }
                    },
                    {
                        "id": "green",
                        "type": "fill",
                        "source": "gozhere",
                        "source-layer": "gis_osm_landuse_a_free_1",
                        "filter": [
                            "in",
                            "fclass",
                            "park",
                            "golf_course"
                        ],
                        "paint": {
                            "fill-color": "#C5E6BB"
                        }
                    },
                    {
                        "id": "primary_routes_zoom_0",
                        "type": "line",
                        "source": "gozhere",
                        "source-layer": "gis_osm_roads_free_1",
                        "filter": [
                            "in",
                            "fclass",
                            "primary",
                            "trunk"
                        ],
                        "paint": {
                            "line-color": "#FEDB52",
                            "line-width": 9
                        }
                    },
                    {
                        "id": "secondary_routes_zoom_0",
                        "type": "line",
                        "source": "gozhere",
                        "source-layer": "gis_osm_roads_free_1",
                        "filter": [
                            "in",
                            "fclass",
                            "secondary"
                        ],
                        "paint": {
                            "line-color": "#F4D26E",
                            "line-width": 6
                        }
                    },
                    {
                        "id": "tertiary_routes_zoom_0",
                        "type": "line",
                        "source": "gozhere",
                        "source-layer": "gis_osm_roads_free_1",
                        "filter": [
                            "in",
                            "fclass",
                            "service",
                            "residential",
                            "tertiary",
                            "unclassified"
                        ],
                        "paint": {
                            "line-color": "#FEFEFA",
                            "line-width": 3
                        }
                    },
                    {
                        "id": "gis_osm_water_a_free_1-label",
                        "type": "symbol",
                        "source": "gozhere",
                        "source-layer": "gis_osm_water_a_free_1",
                        "layout": {
                            "text-font": ["Open Sans Regular"],
                            "text-field": ["get", "name"],
                            "text-padding": 4,
                            "text-max-width": 7,
                            "text-size": 18
                        },
                        "paint": {
                            "text-color": "hsl(196, 76%, 50%)",
                            "text-halo-color": "hsl(35, 7%, 90%)",
                            "text-halo-width": 0.5
                        }
                    },
                    {
                        "id": "gis_osm_waterways_free_1-label",
                        "type": "symbol",
                        "source": "gozhere",
                        "source-layer": "gis_osm_waterways_free_1",
                        "layout": {
                            "text-font": ["Open Sans Regular"],
                            "text-field": ["get", "name"],
                            "text-padding": 4,
                            "text-max-width": 7,
                            "text-size": 18
                        },
                        "paint": {
                            "text-color": "hsl(196, 76%, 50%)",
                            "text-halo-color": "hsl(35, 7%, 90%)",
                            "text-halo-width": 0.5
                        }
                    },
                    {
                        "id": "primary_routes_zoom_0-label",
                        "type": "symbol",
                        "source": "gozhere",
                        "source-layer": "gis_osm_roads_free_1",
                        "layout": {
                            "text-size": [
                                "interpolate",
                                ["linear"],
                                ["zoom"],
                                10,
                                [
                                    "match",
                                    ["get", "fclass"],
                                    [
                                        "motorway",
                                        "trunk",
                                        "primary",
                                        "secondary",
                                        "tertiary"
                                    ],
                                    10,
                                    [
                                        "motorway_link",
                                        "trunk_link",
                                        "primary_link",
                                        "secondary_link",
                                        "tertiary_link",
                                        "street",
                                        "street_limited"
                                    ],
                                    9,
                                    6.5
                                ],
                                18,
                                [
                                    "match",
                                    ["get", "fclass"],
                                    [
                                        "motorway",
                                        "trunk",
                                        "primary",
                                        "secondary",
                                        "tertiary"
                                    ],
                                    16,
                                    [
                                        "motorway_link",
                                        "trunk_link",
                                        "primary_link",
                                        "secondary_link",
                                        "tertiary_link",
                                        "street",
                                        "street_limited"
                                    ],
                                    14,
                                    13
                                ]
                            ],
                            "text-max-angle": 30,
                            "text-font": ["Open Sans Regular"],
                            "symbol-placement": "line",
                            "text-padding": 1,
                            "text-rotation-alignment": "map",
                            "text-pitch-alignment": "viewport",
                            "text-field": ["get", "name"],
                            "text-letter-spacing": 0.01
                        },
                        "paint": {
                            "text-color": "hsl(0,0%, 0%)",
                            "text-halo-color": "hsl(35, 19%, 100%)",
                            "text-halo-width": 1,
                            "text-halo-blur": 1
                        }
                    }
                    
                ]
            },
            center: [120.9779, 14.5905],
            liveCenter: [],
            zoom: 16,
        }
    },
    methods: {
        onMapLoaded(event) {
            console.log(event)
            if (this.savedGps[0] == 0) {
                console.log('gps is currently 0')
            } else {
                console.log('gps is currently not 0')
                this.center = this.savedGps
            }
            
        },
        move(event) {
            console.log('move', event)
            console.log('center', event.map.getCenter())
            this.liveCenter = [
                event.map.getCenter().lng,
                event.map.getCenter().lat
            ]
        },
        click(event) {
            console.log('click', event)
        }
    },
    computed: {
        savedGps: {
            get() {
                return [this.$store.state.gps_longitude, this.$store.state.gps_latitude]
            }
        }
    },
    watch: {

    },
    created() {

    },
    mounted() {
        console.log('mounted map of addnewbusiness')
        this.$root.$on('resizeMapAddNewBusiness', () => {
            console.log('now resizing...')
            this.$nextTick().then(() => {
                this.$refs.glmap2.map.resize()
            });
        });
    }
}
</script>